export { default } from "./SearchModalTabBar";
